/* GPNVG-18 round 2, 13 Oct 2026 (PLAN A2): panoramic callout lines, tube grade slider, add heat switch. No em or en dashes. */
(function () {
  "use strict";
  var root = document.getElementById("no-gpnvg18");
  if (!root || root.dataset.ng2Ready) return;
  root.dataset.ng2Ready = "true";
  var FW = 3440, FH = 1440;

  function queueFn(fn) {
    var raf = 0;
    return function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; fn(); }); };
  }

  // 1. Panoramic view: label cards outside the picture, every line ends ON its feature.
  //    Anchors in the 3440 x 1440 frame of the quad view (quad-nod-view-1013/VIEW-SPEC.md: centres 920 / 1720 / 2520, y 718, radius 441).
  var pano = root.querySelector("[data-ng2-pano]");
  if (pano) {
    var view = pano.querySelector(".ng2-view"), lines = pano.querySelector("[data-ng2-plines]");
    var R = 441, CY = 718, ih = Math.sqrt(R * R - 100 * 100);
    var A = {
      "4L": [479, 718], "4R": [2961, 718], "2": [1720, 205], "3": [1720, CY + R],
      "1L": [1270, 1215], "1R": [2170, 1215]
    };
    var BRACKET = [[479, 205], [2961, 205]];
    var PODS = [[[920, CY + R], [1620, CY + ih]], [[1820, CY + ih], [2520, CY + R]]];
    var RAIL_Y = 1215;
    root.ng2Anchors = A;
    var map = function (vb, pb, p) { return [vb.left - pb.left + p[0] / FW * vb.width, vb.top - pb.top + p[1] / FH * vb.height]; };
    var f = function (n) { return n.toFixed(2); };
    var layoutPano = function () {
      var pb = pano.getBoundingClientRect(), vb = view.getBoundingClientRect();
      if (!vb.width) return;
      // phone dots on the same anchors
      pano.querySelectorAll("[data-ng2-pdot]").forEach(function (d) {
        var p = A[d.dataset.ng2Pdot]; d.style.left = (p[0] / FW * 100).toFixed(3) + "%"; d.style.top = (p[1] / FH * 100).toFixed(3) + "%";
      });
      if (window.innerWidth < 768) { lines.innerHTML = ""; return; }
      lines.setAttribute("viewBox", "0 0 " + pb.width + " " + pb.height);
      var out = "";
      // 2: field of view bracket across the top of the view
      var b0 = map(vb, pb, BRACKET[0]), b1 = map(vb, pb, BRACKET[1]);
      out += '<polyline points="' + f(b0[0]) + "," + f(b0[1] + 12) + " " + f(b0[0]) + "," + f(b0[1]) + " " + f(b1[0]) + "," + f(b1[1]) + " " + f(b1[0]) + "," + f(b1[1] + 12) + '"/>';
      // 1: two pod rails under the circles, a tick up to each tube's bottom edge, a dot on the edge
      PODS.forEach(function (pod) {
        var r0 = map(vb, pb, [pod[0][0], RAIL_Y]), r1 = map(vb, pb, [pod[1][0], RAIL_Y]);
        out += '<line x1="' + f(r0[0]) + '" y1="' + f(r0[1]) + '" x2="' + f(r1[0]) + '" y2="' + f(r1[1]) + '"/>';
        pod.forEach(function (t) { var e = map(vb, pb, t), r = map(vb, pb, [t[0], RAIL_Y]); out += '<line x1="' + f(r[0]) + '" y1="' + f(r[1]) + '" x2="' + f(e[0]) + '" y2="' + f(e[1]) + '"/><circle class="ng2-ld" cx="' + f(e[0]) + '" cy="' + f(e[1]) + '" r="4"/>'; });
      });
      // label leaders
      pano.querySelectorAll("[data-ng2-lab]").forEach(function (lab) {
        var k = lab.dataset.ng2Lab, a = map(vb, pb, A[k]), lb = lab.getBoundingClientRect();
        var top = lb.top < vb.top, L = lb.left - pb.left, Rr = lb.right - pb.left;
        var sy = top ? lb.bottom - pb.top : lb.top - pb.top;
        var midY = top ? (sy + vb.top - pb.top) / 2 : (sy + vb.bottom - pb.top) / 2;
        var pts;
        if (k === "2" || k === "3") pts = [[a[0], sy], a];
        else if (k === "4L" || k === "4R") {
          // route around the outside of the field of view bracket: across above the view, down beside the outer edge, in to the edge
          var sx = k === "4L" ? L + 14 : Rr - 14, ox = k === "4L" ? a[0] - 28 : a[0] + 28;
          pts = [[sx, sy], [sx, midY], [ox, midY], [ox, a[1]], a];
        } else {
          var sx2 = Math.min(Math.max(a[0], L + 14), Rr - 14);
          pts = [[sx2, sy], [sx2, midY], [a[0], midY], a];
        }
        out += '<polyline data-ng2-line="' + k + '" points="' + pts.map(function (p) { return f(p[0]) + "," + f(p[1]); }).join(" ") + '"/>' +
          (k === "1L" || k === "1R" ? "" : '<circle class="ng2-ld" cx="' + f(a[0]) + '" cy="' + f(a[1]) + '" r="5"/>');
      });
      lines.innerHTML = out;
    };
    var qp = queueFn(layoutPano);
    window.addEventListener("resize", qp); window.addEventListener("scroll", qp, { passive: true });
    if ("ResizeObserver" in window) new ResizeObserver(qp).observe(pano);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(qp);
    window.addEventListener("load", qp);
    layoutPano();
  }

  // 2. Tube grade slider (dark block and its dialog). Prices and stock come from the page's own tier pills.
  var grade = root.querySelector("[data-ng2-grade]");
  if (grade) {
    var TIERS = ["1400-1550", "1600-1800", "1800-1950", "2000-2100"];
    var pill = function (t) { return root.querySelector('[data-ng-fom="' + t + '"]'); };
    var priceOf = function (t) { var p = pill(t), e = p && p.querySelector("[data-ng-tier-price]"); return e ? e.textContent.trim() : ""; };
    var num = function (s) { return parseFloat(String(s).replace(/[^0-9.]/g, "")) || 0; };
    var sold = function (t) { var p = pill(t); return !!(p && (p.disabled || p.getAttribute("aria-disabled") === "true")); };
    var fmt0 = function (n) { return "$" + Math.round(n).toLocaleString("en-US"); };
    var dlg = root.querySelector("[data-ng2-dlg]");
    var sliders = Array.from(root.querySelectorAll("[data-ng2-slider]"));
    var cur = 0;
    var setG = function (k) {
      k = Math.max(0, Math.min(3, k | 0)); cur = k;
      var t = TIERS[k];
      root.querySelectorAll(".ng2-gimg, .ng2-dimg").forEach(function (im) { im.classList.toggle("ng2-on", +im.dataset.ng2G === k); });
      sliders.forEach(function (sl) {
        var r = sl.querySelector("[data-ng2-range]"); r.value = String(k); r.setAttribute("aria-valuetext", t + " FOM");
        sl.querySelector("[data-ng2-knob]").style.left = (k / 3 * 100) + "%";
        sl.querySelector("[data-ng2-fill]").style.width = (k / 3 * 100) + "%";
        sl.querySelectorAll("[data-ng2-dot]").forEach(function (d) { var i = +d.dataset.ng2Dot; d.classList.toggle("is-on", i <= k && !sold(TIERS[i])); d.classList.toggle("is-sold", sold(TIERS[i])); });
        sl.querySelectorAll("[data-ng2-stop]").forEach(function (b) { var i = +b.dataset.ng2Stop; b.classList.toggle("is-on", i === k); b.classList.toggle("is-sold", sold(TIERS[i])); });
      });
      var title = grade.querySelector("[data-ng2-gtitle]"); if (title) title.textContent = t + " FOM";
      var gf = grade.querySelector("[data-ng2-gfom]"); if (gf) gf.textContent = "Figure of merit " + t;
      var gp = grade.querySelector("[data-ng2-gprice]"); if (gp) gp.textContent = "Price " + priceOf(t);
      var ga = grade.querySelector("[data-ng2-gavail]"); if (ga) ga.textContent = "Availability: " + (sold(t) ? "sold out" : "built to order");
      var pick = grade.querySelector("[data-ng2-pick]"); if (pick) { pick.disabled = sold(t); pick.textContent = sold(t) ? "SOLD OUT" : "PICK THIS TIER"; }
    };
    var labels = function () {
      var base = num(priceOf(TIERS[0]));
      root.querySelectorAll("[data-ng2-stop-p]").forEach(function (e) {
        var i = +e.dataset.ng2StopP, t = TIERS[i];
        e.textContent = sold(t) ? "SOLD OUT" : i === 0 ? priceOf(t) : "+" + fmt0(num(priceOf(t)) - base);
      });
    };
    sliders.forEach(function (sl) {
      var r = sl.querySelector("[data-ng2-range]");
      r.addEventListener("input", function () { setG(+r.value); });
      r.addEventListener("change", function () { setG(+r.value); });
      sl.querySelectorAll("[data-ng2-stop]").forEach(function (b) { b.addEventListener("click", function () { setG(+b.dataset.ng2Stop); }); });
      // pointer drag on the whole track (mouse, pen and touch); the hidden range keeps the keyboard arrows
      var track = sl.querySelector(".ng2-track"), dragging = false;
      var at = function (e) { var b = track.getBoundingClientRect(); return Math.round(Math.max(0, Math.min(1, (e.clientX - b.left) / b.width)) * 3); };
      track.addEventListener("pointerdown", function (e) { dragging = true; try { track.setPointerCapture(e.pointerId); } catch (x) {} setG(at(e)); e.preventDefault(); });
      track.addEventListener("pointermove", function (e) { if (dragging) setG(at(e)); });
      var end = function (e) { if (!dragging) return; dragging = false; setG(at(e)); try { r.focus({ preventScroll: true }); } catch (x) {} };
      track.addEventListener("pointerup", end); track.addEventListener("pointercancel", function () { dragging = false; });
    });
    var exp = grade.querySelector("[data-ng2-expand]"), lastF = null;
    if (exp && dlg && dlg.showModal) {
      exp.addEventListener("click", function () { lastF = document.activeElement; dlg.showModal(); var c = dlg.querySelector("[data-ng2-close]"); if (c) c.focus(); });
      dlg.querySelector("[data-ng2-close]").addEventListener("click", function () { dlg.close(); });
      dlg.addEventListener("close", function () { if (lastF && lastF.focus) lastF.focus(); });
      dlg.addEventListener("click", function (e) { if (e.target === dlg) dlg.close(); });
    }
    var pickBtn = grade.querySelector("[data-ng2-pick]");
    if (pickBtn) pickBtn.addEventListener("click", function () {
      var p = pill(TIERS[cur]); if (!p || p.disabled) return;
      p.click();
      var tgt = document.getElementById("ng-bundles"); if (tgt) tgt.scrollIntoView({ behavior: "smooth", block: "start" });
    });
    // keep in step with the order card when someone picks a tier there, and refresh labels when stock loads
    root.querySelectorAll("[data-ng-fom]").forEach(function (b) { b.addEventListener("click", function () { var i = TIERS.indexOf(b.dataset.ngFom); if (i >= 0 && !b.disabled) setG(i); }); });
    if ("MutationObserver" in window) {
      var mo = new MutationObserver(queueFn(function () { labels(); setG(cur); }));
      TIERS.forEach(function (t) { var p = pill(t); if (p) mo.observe(p, { attributes: true, attributeFilter: ["disabled", "aria-disabled"], childList: true, subtree: true, characterData: true }); });
    }
    labels(); setG(0);
  }

  // 3. Add heat: COTI off / on switch over one window.
  var field = root.querySelector("[data-ng2-field]");
  if (field) {
    var hb = Array.from(field.querySelectorAll("[data-ng2-hsw]")), hv = Array.from(field.querySelectorAll("[data-ng2-hv]"));
    hb.forEach(function (b) { b.addEventListener("click", function () {
      hb.forEach(function (x) { x.setAttribute("aria-pressed", String(x === b)); });
      hv.forEach(function (i) { i.classList.toggle("ng2-on", i.dataset.ng2Hv === b.dataset.ng2Hsw); });
    }); });
  }
})();
